import React, { useState } from 'react';

import Button from '~/components/button';
import LoadingIndicator from '~/components/loading-indicator';
import { centsToCurrency } from '~/utils/numbers';
import { useCartMutations } from '~/features/cart/cart-actions';
import { cartPurchaseOrderSelector } from '~/features/cart/cart';
import { useFlashMessage } from '~/features/flash-messages/flash-message-actions';
import { useCart } from '~/hooks/use-cart';

import styles from '~/components/cart/cart-summary/cart-summary.module.scss';

const CouponLine = ({ cart, hideDeleteButton, onCouponRemove = () => {} }) => {
  const { removeCoupon } = useCartMutations();
  const { showFlashMessage } = useFlashMessage();
  const [isLoading, setIsLoading] = useState(false);

  // we might be able to get rid of this - we don't use this anywhere we aren't already conditionally checking for a cart
  const { cart: currentCart } = useCart();
  const renderedCart = cart || currentCart;

  const masterCart = cartPurchaseOrderSelector(renderedCart);

  const handleRemoveCoupon = async () => {
    setIsLoading(true);
    const updatedCart = await removeCoupon(cart.uuid);
    onCouponRemove(updatedCart);
    showFlashMessage('Coupon removed.', 'info', 3000);
    setIsLoading(false);
  };

  if (
    !masterCart ||
    (!masterCart?.coupon && masterCart?.discountAmount === 0)
  ) {
    return null;
  }

  return (
    <li className={styles.cartSummaryItem}>
      <span className={styles.couponLine}>
        Coupon code
        <span className={styles.couponCodeWrapper}>
          <span className={styles.couponCode}>{masterCart?.coupon?.code}</span>
          <span data-testid="coupon-amount">
            -{centsToCurrency(masterCart?.discountAmount, { round: false })}
          </span>
        </span>
        {isLoading ? (
          <LoadingIndicator />
        ) : hideDeleteButton ? null : (
          <Button
            className={styles.removeCouponButton}
            type="button"
            variant="link"
            onClick={handleRemoveCoupon}
            aria-label="Remove coupon"
            title="Remove coupon"
          >
            Remove
          </Button>
        )}
      </span>
    </li>
  );
};

export default CouponLine;
